import { render, staticRenderFns } from "./IrcInput.vue?vue&type=template&id=1c8f85d6&"
import script from "./IrcInput.vue?vue&type=script&lang=js&"
export * from "./IrcInput.vue?vue&type=script&lang=js&"
import style0 from "./IrcInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports